module.exports = __webpack_public_path__ + "img/UI_loading_LOGO_01_c6b451154.png";